import styled from "styled-components";

export const Tags = styled.div``;

export const Tag = styled.div`
    display: inline-block;
    padding: 3px 11px;
    font-family: ${({ theme }) => theme.fonts.book};
    font-size: 1.3rem;
    line-height: 2rem;
    color: ${({ theme }) => theme.colors.grey7};
    &:first-child {
        padding-left: 0;
    }
    &:last-child {
        padding-right: 0;
    }
`;
